import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { PendingInvoiceReportModel } from '../../models/configuration/pending-invoice-report.model';
import { ConfigurationRepository } from '../../repositories/configuration.repository';
import { PendingInvoiceReportEntity } from '../../../data/repositories/configuration/entities/pending-invoice-report.entity';
import { InvoiceModel } from '../../models/configuration/invoice.model';

         
    export class GetPendingInvoiceReportUseCase implements UseCase<InvoiceModel, PendingInvoiceReportModel> {
        constructor(private config: ConfigurationRepository) { }
        execute(
            params: InvoiceModel,
        ): Observable<PendingInvoiceReportEntity> {
            return this.config.getInvoiceByDate(params);
        }
    }